import { SessionProvider } from '@/app/providers/session/SessionProvider';
import { AxiosResponseHeaders, RawAxiosResponseHeaders } from 'axios';

export function applyDeviceIdHeadersFactory(sessionProvider: SessionProvider) {
  return function () {
    return sessionProvider.applyDeviceIdHeaders();
  };
}

export function setUserDeviceIdFactory(sessionProvider: SessionProvider) {
  return function (deviceId: string | null | undefined) {
    return sessionProvider.setUserDeviceId(deviceId);
  };
}

export function setUserHeadersFactory(sessionProvider: SessionProvider) {
  return function (headers: RawAxiosResponseHeaders | AxiosResponseHeaders) {
    return sessionProvider.setUserHeaders(headers);
  };
}
